import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';

type NoSignalProps = {
  startPosition: string;
  endPosition: string;
};

const NoSignal = ({ startPosition, endPosition }: NoSignalProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'absolute',
        left: startPosition,
        right: endPosition,
        bottom: 0,
        height: '100%',
        backgroundColor: theme.brandV2.colors.treadGray10,
      }}
    />
  );
};

export default NoSignal;
